/**
 * FolderHeaderActions · 「分类文件夹」页头右侧操作区（PageHeader 的 extra）
 *
 * 由 AIClassifyPage 的 PageHeader 通过 extra 注入。是否渲染（空态隐藏）由页面用
 * hasFolders 决定，本组件不关心空态，只负责把操作按钮排出来：
 *  · 新建文件夹（仅管理员）+ AI 批量分类（侧栏关闭时显示，点击展开侧栏）
 *  · 末尾恒有「⋯ 更多」（下载记录 + 回收站；回收站仅管理员）
 *
 * 多选态批量按钮已下移到列表操作栏（FolderListToolbar），页头恒显常规按钮，
 * 不再随 manageMode 切换为 portal 空槽位。sidebarOpen / isAdmin 由本组件自行从
 * store / hook 读取；打开弹窗 / 抽屉这些「页面协调」职责由 props 注入。
 */

import React from 'react'
import { Button } from 'antd'
import { FolderAddOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector, useIsAdmin } from '../../../app/hooks'
import { selectSidebarOpen, toggleSidebar } from '../../../slices/aiClassify'
import AITriggerButton from './AISidebar/AITriggerButton'
import MoreActionsMenu from './MoreActionsMenu'
import { trackClassifyClick } from '../utils/trackClassify'
import styles from './FolderHeaderActions.module.scss'

export interface FolderHeaderActionsProps {
  /** 打开「新建文件夹」弹窗 · 弹窗状态在页面 */
  onCreateFolder: () => void
  /** 打开「回收站」抽屉 · 抽屉状态在页面；组件内部按 isAdmin 决定是否暴露入口 */
  onOpenRecycleBin: () => void
}

const FolderHeaderActions: React.FC<FolderHeaderActionsProps> = ({
  onCreateFolder,
  onOpenRecycleBin
}) => {
  const dispatch = useAppDispatch()
  const sidebarOpen = useAppSelector(selectSidebarOpen)
  const isAdmin = useIsAdmin()

  return (
    <div className={styles.actions}>
      {isAdmin && (
        <Button
          icon={<FolderAddOutlined />}
          onClick={() => {
            trackClassifyClick('createFolder')
            onCreateFolder()
          }}
        >
          新建文件夹
        </Button>
      )}
      {!sidebarOpen && (
        <AITriggerButton
          onClick={() => {
            trackClassifyClick('aiAssistant')
            dispatch(toggleSidebar())
          }}
          label="AI 批量分类"
        />
      )}
      <MoreActionsMenu
        className={styles.btnFlat}
        onOpenRecycleBin={isAdmin ? onOpenRecycleBin : undefined}
      />
    </div>
  )
}

export default FolderHeaderActions
